/* eslint-disable */
import OperatorsFilterView from '@/js/desktop/components/filterCriteria/OperatorsFilter';
import DataLayerAnalytics from '@/js/common/Domain/Service/DataLayerAnalytics';
import WaterActivitiesDesktop
	from '@/js/desktop/components/filterCriteria/waterActivitiesDesktop/WaterActivitiesDesktop';
import { freeCancelingService } from '@/js/common/Domain/Service';
import WarrantedView from '@/js/desktop/components/searchForm/warranted/WarrantedView';
import EmiratesView from '@/js/desktop/components/searchForm/emirates/EmiratesView';
import DirectFlightFilter from '@/js/desktop/components/directFlight/DirectFlight';

import '@/css/common/components/warranted-icon.scss';

let FilterCriteriaView = Backbone.Epoxy.View.extend({
	el:'.sideBlock.filters',
	bindings: {
		".children_animators label":"classes:{checked:children_animators}",
		".children_animators input": "checked:children_animators",
		".children_pool label":"classes:{checked:children_pool}",
		".children_pool input": "checked:children_pool",
		".children_waterslides label":"classes:{checked:children_waterslides}",
		".children_waterslides input": "checked:children_waterslides",
		".children_aquapark label":"classes:{checked:children_aquapark}",
		".children_aquapark input": "checked:children_aquapark",
		".children_seaEnter label":"classes:{checked:children_seaEnter}",
		".children_seaEnter input": "checked:children_seaEnter",
		".children_childmenu label":"classes:{checked:children_childmenu}",
		".children_childmenu input": "checked:children_childmenu",
		".children_childBed label":"classes:{checked:children_childBed}",
		".children_childBed input": "checked:children_childBed",
		".children_nanny label":"classes:{checked:children_nanny}",
		".children_nanny input": "checked:children_nanny",
		".children_clubs label":"classes:{checked:children_clubs}",
		".children_clubs input": "checked:children_clubs",
		".withKids label":"classes:{checked:withKids}",
		".withKids input": "checked:withKids",
		".adultsOnly label":"classes:{checked:adultsOnly}",
		".adultsOnly input": "checked:adultsOnly",
		".forCouples label":"classes:{checked:forCouples}",
		".forCouples input": "checked:forCouples",
		".nearTheBeach label":"classes:{checked:nearTheBeach}",
		".nearTheBeach input": "checked:nearTheBeach",
		".nearTheLift label":"classes:{checked:nearTheLift}",
		".nearTheLift input":"checked:nearTheLift",

		".beachLinesList .allLines label": "classes:{checked:allLines}",
		".beachLinesList .allLines input": "checked:allLines",
		".beachLinesList .firstLine label": "classes:{checked:firstLine}",
		".beachLinesList .firstLine input": "checked:firstLine",
		".beachLinesList .secondLine label": "classes:{checked:secondLine}",
		".beachLinesList .secondLine input": "checked:secondLine",
		".beachLinesList .thirdLine label": "classes:{checked:thirdLine}",
		".beachLinesList .thirdLine input": "checked:thirdLine",

		".beachOwner label":"classes:{checked:beachOwner}",
		".beachOwner input":"checked:beachOwner",

		'.lonelyMan label': 'classes:{checked:lonelyMan}',
		'.lonelyMan input': 'checked:lonelyMan',
        '.cashback label': 'classes:{checked:cashback}',
        '.cashback input': 'checked:cashback',
		".nearTheCenter label":"classes:{checked:nearTheCenter}",
		".nearTheCenter input":"checked:nearTheCenter",
		".airConditioner label":"classes:{checked:airConditioner}",
		".airConditioner input": "checked:airConditioner",
		".wifi label":"classes:{checked:wifi}",
		".wifi input": "checked:wifi",
		".wellness label":"classes:{checked:wellness}",
		".wellness input": "checked:wellness",
		".pool label":"classes:{checked:pool}",
		".pool input": "checked:pool",
		".heatedPool label":"classes:{checked:heatedPool}",
		".aquapark label":"classes:{checked:aquapark}",
		".animation label":"classes:{checked:animation}",
		".animation input": "checked:animation",
		".familyRooms label":"classes:{checked:familyRooms}",
		".familyRooms input": "checked:familyRooms",
		".diving label":"classes:{checked:diving}",
		".diving input": "checked:diving",
		".freeSafe label":"classes:{checked:freeSafe}",
		".freeSafe input": "checked:freeSafe",
		".fitnessCenter label":"classes:{checked:fitnessCenter}",
		".fitnessCenter input": "checked:fitnessCenter",
		".freeMiniBar label":"classes:{checked:freeMiniBar}",
		".freeMiniBar input": "checked:freeMiniBar",
		".skiEquipment label":"classes:{checked:skiEquipment}",
		".skiEquipment input": "checked:skiEquipment",
		".honeyMoon label":"classes:{checked:honeyMoon}",
		".honeyMoon input": "checked:honeyMoon",
		".waterSports label":"classes:{checked:waterSports}",
		".waterSports input": "checked:waterSports",
		".spaAndHealth label":"classes:{checked:spaAndHealth}",
		".spaAndHealth input": "checked:spaAndHealth",
		".nightClub label":"classes:{checked:nightClub}",
		".nightClub input": "checked:nightClub",
		".personsWithDisabilities label":"classes:{checked:personsWithDisabilities}",
		".personsWithDisabilities input": "checked:personsWithDisabilities",
		".noSmokingRooms label":"classes:{checked:noSmokingRooms}",
		".noSmokingRooms input": "checked:noSmokingRooms",
		".smokingRooms label":"classes:{checked:smokingRooms}",
		".smokingRooms input": "checked:smokingRooms",

		".ratingFilter .best label":"classes:{checked:best}",
		".ratingFilter .best input":"checked:best",
		".ratingFilter .better label":"classes:{checked:better}",
		".ratingFilter .better input":"checked:better",
		".ratingFilter .good label":"classes:{checked:good}",
		".ratingFilter .good input":"checked:good",
		".ratingFilter .satisfactorily label":"classes:{checked:satisfactorily}",
		".ratingFilter .satisfactorily input":"checked:satisfactorily",
		".ratingFilter .allScore label":"classes:{checked:allScore}",
		".ratingFilter .allScore input":"checked:allScore",

		".ratingFilter .noScore label":"classes:{checked:noScore}",
		".ratingFilter .noScore input":"checked:noScore",

		".locationFilterReview label":"classes:{checked:ratingLocation}",
		".serviceFilterReview label":"classes:{checked:ratingService}",
		".mealFilterReview label":"classes:{checked:ratingMeal}",

		".locationFilterReview .filterReviewLinesWrapper": "html:scoreReviewsLocation",
		".serviceFilterReview .filterReviewLinesWrapper":"html:scoreReviewsService",
		".mealFilterReview .filterReviewLinesWrapper":"html:scoreReviewsMeal",
		".locationFilterReview .filterReviewLinesWrapperStatic":"html:scoreReviewsStatic",
		".serviceFilterReview .filterReviewLinesWrapperStatic":"html:scoreReviewsStatic",
		".mealFilterReview .filterReviewLinesWrapperStatic":"html:scoreReviewsStatic",

		".sandBeach label":"classes:{checked:equal(beachType,'sandBeach')}",
		".sandBeach input": "setUnset:['change','beachType','sandBeach'], checkedSet:['change','beachType','sandBeach']",
		".pebbleBeach label":"classes:{checked:equal(beachType,'pebbleBeach')}",
		".pebbleBeach input": "setUnset:['change','beachType','pebbleBeach'], checkedSet:['change','beachType','pebbleBeach']",
		".beachAny input": "attr: { checked: (beachType) }",

		".openPool input": "checked:openPool",
		".closePool input": "checked:closePool",
		".heatedPool input": "checked:heatedPool",
		".seaPool input": "checked:seaPool",
		".kidsPool input": "checked:kidsPool",
		".waterslides input": "checked:waterslides",
		".aquapark input": "checked:aquapark",
		".saunaBathHammam input": "checked:saunaBathHammam",
		".jacuzzi input": "checked:jacuzzi",
		".freeCancellation input": "checked:freeCancellation",
	},
	initCompopents:function() {
		this.operators = new OperatorsFilterView({
			searchPageModel:this.searchPageModel,
			model:this.model,
			el:$('.operatorFilter', this.$el)
		});
		new WaterActivitiesDesktop({
			el:$('.waterActivities', this.$el),
			searchPageModel: this.searchPageModel,
		});

		this.warrantedFilter = new WarrantedView({
			model: this.searchFormViewModel.get('warranted'),
			el: $('.js-warranted-checkbox', this.$el),
		});

		this.emiratesFilter = new EmiratesView({
			model: this.searchFormViewModel.get('block'),
			searchPageModel: this.searchPageModel,
			el: $('.js-emirates-checkbox', this.$el),
		});

		new DirectFlightFilter({
			model: this.searchFormViewModel.get('directFlight'),
			searchPageModel: this.searchPageModel,
			el: $('.js-direct-flight-checkbox', this.$el),
		});
	},
	initialize: function(options) {
		this.model = options.model;
		this.searchPageModel = options.searchPageModel;
		this.searchFormViewModel = options.searchFormViewModel;
		this.dataLayerAnalytics = options.dataLayerAnalytics;
		this.initModelEvents();
		this.initCompopents();
	},
	offUnusedFilters:function(model, value) {
		var filteredHotes = this.searchPageModel.get('filteredHotels'),
			self = this;

		if(filteredHotes && filteredHotes.length) {
			for (var i in self.model.attributes) {
				if (self.model.attributes.hasOwnProperty(i) && self.searchPageModel.attributes.hasOwnProperty(i + 'Count') && self.model.get(i) && !self.searchPageModel.get(i + 'Count')) {
					self.model.set(i, false);
				}
			}
		}
	},
	initModelEvents:function() {
		var self = this;
		this.model.on('change', $.proxy(this.offUnusedFilters, this));
		this.searchPageModel.on('change:filteredHotels', function() {
			setTimeout(function() {
				self.offUnusedFilters();
			}, 0);
		});

		this.model.on('change:ratingLocation', $.proxy(this.updateScoreReviewsLocation, this));
		this.searchPageModel.on('change:ratingLocationMax', $.proxy(this.updateScoreReviewsLocation, this));

		this.model.on('change:ratingService', $.proxy(this.updateScoreReviewsService, this));
		this.searchPageModel.on('change:ratingServiceMax', $.proxy(this.updateScoreReviewsService, this));

		this.model.on('change:ratingMeal', $.proxy(this.updateScoreReviewsMeal, this));
		this.searchPageModel.on('change:ratingMealMax', $.proxy(this.updateScoreReviewsMeal, this));
	},
	events: {
		"click .locationFilterReview .labelTag.checked":"ratingLocationUnset",
		"click .serviceFilterReview .labelTag.checked":"ratingServiceUnset",
		"click .mealFilterReview .labelTag.checked":"ratingMealUnset",
		"click .locationFilterReview .filterReviewLinesWrapper span":"ratingLocationClick",
		"click .serviceFilterReview .filterReviewLinesWrapper span":"ratingServiceClick",
		"click .mealFilterReview .filterReviewLinesWrapper span":"ratingMealClick",
		"click .locationFilterReview .filterReviewLinesWrapperStatic span":"ratingLocationClick",
		"click .serviceFilterReview .filterReviewLinesWrapperStatic span":"ratingServiceClick",
		"click .mealFilterReview .filterReviewLinesWrapperStatic span":"ratingMealClick",
		'click .beachLinesList .allLines input': 'allLinesClick',
		'click .beachLinesList .firstLine input': 'firstLineClick',
		'click .beachLinesList .secondLine input': 'secondLineClick',
		'click .beachLinesList .thirdLine input': 'thirdLineClick',
		'click .beachOwner input': 'beackOwnerClick',
		'click .dynamicFilters input[type=checkbox]': "filterClick",
		'click .filtersList__item-extra': 'extraHandler',
		'click .ratingFilter .checkbox': 'radioHandler',
		'click .beachAny .checkbox': 'beachAny',
	},
	beachAny() {
        this.model.set('beachType', 0);
    },
    extraHandler(e) {
        const eventsTargetElements = this.getTargetsData(e);
        this.setValueAsRadioInput(eventsTargetElements);
    },
    radioHandler(e) {
        e.preventDefault();

        const { targetsCheckbox, filtersList } = this.getTargetsData(e);

        if (!targetsCheckbox.is( ":checked" )) {
            this.setValueAsRadioInput({ targetsCheckbox, filtersList });
        }
    },
    setValueAsRadioInput({ targetsCheckbox, filtersList }) {
        _.each(filtersList.children(), ($filter) => {
            const $input = $('input', $filter);

            $input
                .prop('checked', false)
                .trigger('change');
        });

        targetsCheckbox
            .prop('checked', true)
            .trigger('change');
    },
    getTargetsData(e) {
        const targetsParent = $(e.target).parents('.filtersList__item');
    
        return {
            targetsCheckbox: $('input', targetsParent),
            filtersList: $(e.target).parents('.filtersList'),
        };
    },
	linkToFreeCancelRulesClickHandler: function (e) {
		freeCancelingService(e);
	},
	filterClick: function (e) {
		if(!this.dataLayerAnalytics){return}
		var self = this,
			$this = $(e.target),
			checked = $this.is('.js-all-filters-value') ? true : $this.is(":checked"),
			value = $this.data("layer-name");
		setTimeout(function () {
			//ожидание пересчета всех счетчиков
			DataLayerAnalytics.toggleFilter(checked, value);
			self.dataLayerAnalytics.filterCountEvent(self.searchPageModel.get("filteredHotels").length)
		},100);
	},
	preventCheckboxUncheck:function(event) {
		if(!$(event.target).is(':checked')) {
			event.preventDefault();
		}
	},
	allLinesClick:function(event) {
		if($(event.target).is(':checked')) {
			this.analyticsEvents('beach_line_any');
		}
		this.preventCheckboxUncheck(event);
	},
	firstLineClick:function() {
		this.analyticsEvents('beach_line_1');
	},
	secondLineClick:function() {
		this.analyticsEvents('beach_line_2');
	},
	thirdLineClick:function() {
		this.analyticsEvents('beach_line_3');
	},
	beackOwnerClick:function() {
		this.analyticsEvents('beach_owner');
	},
	analyticsEvents: function(value) {
		var dataLayer = window.dataLayer || [];
		dataLayer.push({
			'event': 'sideBarFilter',
			'beach': value
		});
	},
	viewModel: new (Backbone.Epoxy.Model.extend({
		defaults: {
			scoreReviewsLocation: '',
			scoreReviewsService: '',
			scoreReviewsMeal: '',
			scoreReviewsStatic: '<span data-rv="1" class="filterReviewLineDefault"></span><span data-rv="2" class="filterReviewLineDefault"></span><span data-rv="3" class="filterReviewLineDefault"></span><span data-rv="4" class="filterReviewLineDefault"></span><span data-rv="5" class="filterReviewLineDefault"></span>'
		}
	}))(),

	updateScoreReviewsLocation: function() {
		var html = '',
			index = 1,
			ratingLocation = this.model.get('ratingLocation'),
			ratingLocationMax = this.searchPageModel.get('ratingLocationMax');

		for(var i = 0; i < ratingLocation; i++) {
			if(index <= ratingLocationMax) {
				html += '<span data-rv="' + index + '" class="filterReviewLine r' + ratingLocation + '"></span>';
				index++;
			}
		}
		for(var i = 0; i < 5 - ratingLocation; i++) {
			if(index <= ratingLocationMax) {
				html += '<span data-rv="' + index + '" class="filterReviewLineDefault"></span>';
			}
			index++;
		}

		this.viewModel.set('scoreReviewsLocation', html);
	},
	updateScoreReviewsService:function() {
		var html = '',
			index = 1,
			ratingService = this.model.get('ratingService'),
			ratingServiceMax = this.searchPageModel.get('ratingServiceMax');

		for(let i = 0; i < ratingService; i++) {
			if(index <= ratingServiceMax) {
				html += '<span data-rv="' + index + '" class="filterReviewLine r' + ratingService + '"></span>';
			}
			index++;
		}
		for(let i = 0; i < 5 - ratingService; i++) {
			if(index <= ratingServiceMax) {
				html += '<span data-rv="' + index + '" class="filterReviewLineDefault"></span>';
			}
			index++;
		}
		this.viewModel.set('scoreReviewsService', html);
	},
	updateScoreReviewsMeal: function() {
		var html = '',
			index = 1,
			ratingMeal = this.model.get('ratingMeal'),
			ratingMealMax = this.searchPageModel.get('ratingMealMax');

		for(var i = 0; i < ratingMeal; i++) {
			if(index <= ratingMealMax) {
				html += '<span data-rv="' + index + '" class="filterReviewLine r' + ratingMeal + '"></span>';
			}
			index++;
		}
		for(var i = 0; i < 5 - ratingMeal; i++) {
			if(index <= ratingMealMax) {
				html += '<span data-rv="' + index + '" class="filterReviewLineDefault"></span>';
			}
			index++;
		}
		this.viewModel.set('scoreReviewsMeal', html);
	},
	ratingLocationUnset: function() {
		this.model.set('ratingLocation', 0);
	},
	ratingServiceUnset: function() {
		this.model.set('ratingService', 0);
	},
	ratingMealUnset: function() {
		this.model.set('ratingMeal', 0);
	},
	ratingLocationClick: function(e) {
		var selectedRating = $(e.currentTarget).data('rv');
		this.model.set('ratingLocation', selectedRating);
	},
	ratingServiceClick: function(e) {
		var selectedRating = $(e.currentTarget).data('rv');
		this.model.set('ratingService', selectedRating);
	},
	ratingMealClick: function(e) {
		var selectedRating = $(e.currentTarget).data('rv');
		this.model.set('ratingMeal', selectedRating);

	}
});

export default FilterCriteriaView;
